<template>
  <div class="eligibilityBirthday">
    <b-alert
      :show="!isOnboardingRedesign && alert.show"
      :variant="alert.type"
    >
      {{ alert.message }}
    </b-alert>
    <h2
      v-if="isOnboardingRedesign"
      class="question-title with-subtext"
    >
      Please enter your birthday.
    </h2>
    <h2
      v-else
      class="question-title with-subtext"
    >
      When is your birthday?
    </h2>
    <p
      v-if="isOnboardingRedesign"
      class="sub-text group-mb tw-mt-4"
    >
      Your age helps us to determine if you’re eligible for treatment through Winona.
    </p>
    <p
      v-else
      class="sub-text group-mb"
    >
      Age helps us to determine if you are eligible for treatment.
    </p>
    <b-row>
      <b-col>
        <div
          role="group"
          class="mb-3 pb-1"
        >
          <template v-if="isOnboardingRedesign">
            <b-form-input
              id="birthday"
              v-model="birthday"
              v-mask="'##/##/####'"
              placeholder="MM/DD/YYYY*"
              class="fs-exclude onboarding-input birthdate !tw-bg-white tw-block lg:tw-hidden"
              type="text"
              pattern="[0-9]*"
              inputmode="numeric"
              autocomplete="off"
              readonly
              @click="showBirthdayModal = true"
            />
            <b-form-input
              id="birthday"
              v-model="birthday"
              v-mask="'##/##/####'"
              placeholder="MM/DD/YYYY*"
              class="fs-exclude onboarding-input birthdate !tw-bg-white tw-hidden lg:tw-block"
              type="text"
              pattern="[0-9]*"
              inputmode="numeric"
              autocomplete="off"
            />
          </template>
          <template v-else>
            <label
              for="birthday"
              class="input-label"
            >Date of birth*</label>
            <b-form-input
              id="birthday"
              v-model="birthday"
              v-mask="'##/##/####'"
              :placeholder="isOnboardingRedesign ? 'MM/DD/YYYY*' : 'MM/DD/YYYY'"
              class="fs-exclude onboarding-input birthdate"
              type="text"
              pattern="[0-9]*"
              inputmode="numeric"
              autocomplete="off"
            />
          </template>
        </div>
        <template v-if="isOnboardingRedesign">
          <div class="tw-mt-4 tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.97266 14.2422C6.02018 14.2422 5.1224 14.0599 4.2793 13.6953C3.44076 13.3307 2.7002 12.8271 2.05762 12.1846C1.41504 11.542 0.911458 10.8014 0.546875 9.96289C0.182292 9.11979 0 8.22201 0 7.26953C0 6.31706 0.182292 5.42155 0.546875 4.58301C0.911458 3.73991 1.41276 2.99707 2.05078 2.35449C2.69336 1.71191 3.43392 1.20833 4.27246 0.84375C5.11556 0.479167 6.01335 0.296875 6.96582 0.296875C7.91829 0.296875 8.81608 0.479167 9.65918 0.84375C10.5023 1.20833 11.2451 1.71191 11.8877 2.35449C12.5303 2.99707 13.0339 3.73991 13.3984 4.58301C13.763 5.42155 13.9453 6.31706 13.9453 7.26953C13.9453 8.22201 13.763 9.11979 13.3984 9.96289C13.0339 10.8014 12.5303 11.542 11.8877 12.1846C11.2451 12.8271 10.5023 13.3307 9.65918 13.6953C8.82064 14.0599 7.92513 14.2422 6.97266 14.2422ZM6.97266 13.0801C7.7793 13.0801 8.53353 12.9297 9.23535 12.6289C9.93717 12.3281 10.5547 11.9134 11.0879 11.3848C11.6211 10.8516 12.0358 10.234 12.332 9.53223C12.6328 8.8304 12.7832 8.07617 12.7832 7.26953C12.7832 6.46289 12.6328 5.70866 12.332 5.00684C12.0312 4.30501 11.6143 3.6875 11.0811 3.1543C10.5524 2.62109 9.9349 2.20638 9.22852 1.91016C8.52669 1.60938 7.77246 1.45898 6.96582 1.45898C6.15918 1.45898 5.40495 1.60938 4.70312 1.91016C4.0013 2.20638 3.38607 2.62109 2.85742 3.1543C2.32878 3.6875 1.91406 4.30501 1.61328 5.00684C1.31706 5.70866 1.16895 6.46289 1.16895 7.26953C1.16895 8.07617 1.31706 8.8304 1.61328 9.53223C1.91406 10.234 2.32878 10.8516 2.85742 11.3848C3.39062 11.9134 4.00814 12.3281 4.70996 12.6289C5.41178 12.9297 6.16602 13.0801 6.97266 13.0801ZM6.96582 8.5C6.61491 8.5 6.4349 8.31999 6.42578 7.95996L6.33691 4.34375C6.33236 4.17057 6.38704 4.02702 6.50098 3.91309C6.61947 3.79915 6.77214 3.74219 6.95898 3.74219C7.14128 3.74219 7.29167 3.80143 7.41016 3.91992C7.5332 4.03385 7.59245 4.17741 7.58789 4.35059L7.48535 7.95996C7.48079 8.31999 7.30762 8.5 6.96582 8.5ZM6.96582 10.7217C6.7653 10.7217 6.59212 10.6533 6.44629 10.5166C6.30046 10.3753 6.22754 10.2067 6.22754 10.0107C6.22754 9.81478 6.30046 9.64844 6.44629 9.51172C6.59212 9.37044 6.7653 9.2998 6.96582 9.2998C7.16634 9.2998 7.33952 9.36816 7.48535 9.50488C7.63119 9.6416 7.7041 9.81022 7.7041 10.0107C7.7041 10.2113 7.62891 10.3799 7.47852 10.5166C7.33268 10.6533 7.16178 10.7217 6.96582 10.7217Z"
                fill="#1A6A72"
              />
            </svg>
            <div>
              Fields marked with<span class="tw-text-[#1A6A72] tw-px-0.5">*</span>are required.
            </div>
          </div>
          <ErrorLabel v-if="isOnboardingRedesign && alert.show && birthday !== ''">
            {{ alert.message }}
          </ErrorLabel>
        </template>
        <img
          :src="isOnboardingRedesign ? require(`@/assets/images/cro/hsa-fsa-eligible-badge.svg`) : require(`@/assets/images/cro/hsa-fsa-eligible-badge.png`)"
          alt=""
          class="tw-mx-auto"
          :class="isOnboardingRedesign ? 'tw-h-[30px]' : 'tw-h-[18px]'"
        >
        <OnboardingCTAContainer>
          <div class="tw-w-full tw-flex tw-flex-col tw-gap-2">
            <b-button
              pill
              block
              variant="info"
              class="slight-rounded"
              :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
              :disabled="isOnboardingRedesign ? isBirthdayInvalid : buttonDisabled"
              @click="submitAnswer"
            >
              Continue
            </b-button>
          </div>
        </OnboardingCTAContainer>
      </b-col>
    </b-row>
    <Modal
      v-if="showModal"
      :body="ageModal"
      @submitAnswer="$emit('exit')"
    />
    <CoreBottomSlideOutPanel
      :model-value="showBirthdayModal"
      :should-swipe-down="true"
      @update:modelValue="$event => (showBirthdayModal = $event)"
    >
      <template #header>
        <div class="tw-w-full tw-flex tw-justify-between tw-z-10 tw-px-5 tw-mb-2">
          <span
            class="close-bottom-modal tw-z-10 tw-text-lg tw-text-[#828282] tw-cursor-pointer"
            @click="showBirthdayModal = false"
          >
            Cancel
          </span>
          <span
            class="tw-text-md tw-mb-0 tw-text-lg tw-font-bold"
          >
            Select Date
          </span>
          <span
            class="tw-text-[#AF8EFF] tw-text-lg tw-cursor-pointer"
            @click="handleChange"
          >
            Confirm
          </span>
        </div>
        <div class="tw-w-full tw-h-[1px] border-bottom md:!tw-top-[60px] tw-border-[#C7C7C7]"></div>
      </template>
      <div
        class="min-[320px]:text-center md:tw-scale-[1.1] tw-origin-top tw-my-auto"
      >
        <BaseDatePicker
          v-model="date"
        />
      </div>
    </CoreBottomSlideOutPanel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { parse, differenceInYears, isValid } from 'date-fns';
// components
import Modal from '@/components/onboarding/questions/Modal';
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import CoreBottomSlideOutPanel from '@corefront/components-v2/CoreBottomSlideOutPanel/CoreBottomSlideOutPanel.vue';
import BaseDatePicker from '@/components/base/DatePicker';

// mixins
import mixins from '@/components/form/mixins';
import analyticsMixin from '@/mixins/analytics';
import ErrorLabel from '@/components/partials/ErrorLabel.vue';

const validDateErrorMessage = 'Please enter a valid date.';

export default {
  components: {
    ErrorLabel,
    OnboardingCTAContainer,
    Modal,
    BaseDatePicker,
    CoreBottomSlideOutPanel,
  },
  mixins: [mixins, analyticsMixin],
  props: {
    onboardingflow: {
      type: String,
      default: 'flowA',
    },
    preAnswer: {
      type: String,
      default: '',
    },
    externalid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dateFormat: 'MM/DD/YYYY',
      birthday: '',
      date: new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }),
      buttonDisabled: false,
      showModal: false,
      showBirthdayModal: false,
      alert: {
        show: false,
        type: '',
        message: '',
      },
      ageModal: {
        id: 'ageModal',
        title: 'You must be 35 years of age or older to proceed',
        answerlist: [
          {
            name: 'continue',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    isBirthdayInvalid() {
      if (!this.birthday) {
        return true;
      }

      const dateString = this.birthday.split('/');

      if (dateString.length !== 3) {
        return true;
      }

      const year = dateString[2].replace(/^0+/, '');
      const month = dateString[0];
      const day = dateString[1];

      const dateToCheck = `${month}/${day}/${year}`
      if (!this.moment(dateToCheck, this.dateFormat, true).isValid()) {
        return true;
      }

      const age = this.calculateAge(dateToCheck);
      if (age === false || age < 0 || age > 100) {
        return true;
      }

      return false;
    },
  },
  watch: {
    showBirthdayModal(val) {
      if (val) {
        window.Intercom('update', {
          hide_default_launcher: true,
        });
      } else {
        window.Intercom('update', {
          hide_default_launcher: false,
        });
      }
    },
    isBirthdayInvalid: {
      handler: function(value) {
        if (!value){
          this.alert = {
            show: false,
            type: '',
            message: '',
          };
        } else {
          this.alert = {
            show: true,
            type: 'warning',
            message: validDateErrorMessage
          };
        }
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.preAnswer) {
      this.birthday = this.formatBirthdayForDisplay(this.preAnswer);
      this.date = this.formatBirthdayForDisplay(this.preAnswer);
    }

    await this.$store.dispatch('onboarding/getPatientOnboarding')

    this.$_analytics_track(
      'Onboarding Screen Viewed',
      {
        screen: '1.2-A',
        onboardingflow: this.onboardingflow,
      }
    );
  },
  methods: {
    handleChange() {
      const dateString = this.date.split('/');
      const month = dateString[0].padStart(2, '0');
      const day = dateString[1].padStart(2, '0');
      const year = dateString[2].padStart(4, '0');
      this.birthday = `${month}/${day}/${year}`;
      this.showBirthdayModal = false;
    },
    showAlert(message, type = null) {
      if (!type) type = 'warning';
      this.alert = {
        show: true,
        type: 'warning',
        message: message,
      };
      if (this.isOnboardingRedesign){
        window.scrollTo(0, document.documentElement.scrollHeight);
      } else {
        window.scrollTo(0, 0);
      }
    },
    async calculateAge() {
      const date = parse(this.birthday, 'MM/dd/yyyy', new Date());
      if (!isValid(date)) {
        this.showAlert(validDateErrorMessage);
        return false;
      }
      const now = new Date();
      const age = differenceInYears(now, date);
      // Check for future dates
      if (date > now || age < 0) {
        this.showAlert(validDateErrorMessage);
        return false;
      }
      return age;
    },
    formatBirthdayForDisplay(date) {
      const dateString = date.split('-');
      return `${dateString[1]}/${dateString[2]}/${dateString[0]}`;
    },
    formatBirthday(date) {
      const dateString = date.split('/');
      const yyyy = dateString[2];
      const mm = dateString[0];
      const dd = dateString[1];
      return `${yyyy}-${mm}-${dd}`;
    },
    async submitAnswer() {
      const dateString = this.birthday.split('/');
      if (dateString.length == 3) {
        dateString[2] = dateString[2].replace(/^0+/, '');
      } else {
        this.buttonDisabled = false;
        this.showAlert(validDateErrorMessage);
        return;
      }

      this.birthday = `${dateString[0]}/${dateString[1]}/${dateString[2]}`;
      if (!this.moment(this.birthday, this.dateFormat, true).isValid()) {
        this.showAlert(validDateErrorMessage);
        return;
      }

      // Checks if age is within the limits -- false is returned if a future date is entered
      const age = await this.calculateAge();

      if (age < 35 || age >= 60) {
        const rejectBody = {
          externalid: this.externalid,
          question: 'How old are you?',
          answer: await this.calculateAge(),
          onboardingflow: this.onboardingflow,
          ...(['H', 'J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingPatient?.flow_variant) && {
            rejectionType: (age <= 35 || age >= 60) && age >= 18 ? 'Soft' : 'Hard' }
          )
        };

        this.$_analytics_track('Onboarding Reject', rejectBody);
      }

      if (age < 0 || age > 100 || age === false) {
        this.buttonDisabled = false;
        this.showAlert(validDateErrorMessage);
        return;
      } else if (age < 35) {
        this.buttonDisabled = false;
        if (this.isOnboardingRedesign) {
          if (['H', 'J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingPatient?.flow_variant) && age < 18) {
            this.$emit('setStep', 'under18');
          } else {
            this.$emit('setParams', 'birthday', this.formatBirthday(this.birthday));
            this.$emit('setStep', 'under35');
          }

          this.$store.commit('global/SET_IS_SOFT_REJECTED', true);
        }
        this.showModal = true;
        return;
      }

      this.$emit('setParams', 'birthday', this.formatBirthday(this.birthday));

      // Checks if empty
      if (this.birthday === '') {
        this.buttonDisabled = false;
        this.showAlert('Enter your birthday');
        return;
      } else if (age >= 60) {
        this.buttonDisabled = false;

        this.$store.commit('global/SET_IS_SOFT_REJECTED', true);
        this.$emit('setStep', 'over60');
      } else {
        this.$store.commit('global/SET_IS_SOFT_REJECTED', false);
        this.buttonDisabled = false;
        this.$emit('setStep', 'sex');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
}

.redesign {
  .custom-modal{
    position: fixed;
  }
  .custom-modal__body{
    background-color: white;
  }
  .table-datepicker{
    transform: scale(1.9);
    transform-origin: top;
  }
  .border-bottom{
    position: absolute;
    left: 0;
    top: 56px;
    z-index: 2;
    background-color: #d8d8d8;
  }
}
</style>
